module.exports = __webpack_public_path__ + "img/079-st-barts.1e302a28.svg";